import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Folosim cookie-uri',
    description:
      'Folosim cookie-uri și tehnologii similare pentru a asigura funcționarea acestei experiențe. Cookie-urile strict necesare sunt întotdeauna active.',
    allow_label: 'Acceptă toate cookie-urile',
    reject_label: 'Doar cele strict necesare',
    settings_label: 'Setări cookie-uri',
    policy_link_label: 'Politica de confidențialitate și cookie-uri',
    categories_label: 'Categorii',
    always_on_label: 'Întotdeauna active',
    required_label: 'Obligatoriu',
    save_preferences_label: 'Salvează preferințele',
    close_label: 'Închide',
    allow_all_optional_categories_label: 'Permite toate categoriile opționale',
    save_error: 'Nu am putut salva opțiunea dvs. de confidențialitate. Vă rugăm să încercați din nou.'
  },
  categories: {
    strictly_necessary: {
      name: 'Strict necesare',
      purpose: 'Sunt necesare pentru funcționarea acestei experiențe și nu pot fi dezactivate.'
    },
    analytics: {
      name: 'Analiză',
      purpose: 'Măsoară modul în care vizitatorii folosesc această experiență, pentru a îmbunătăți performanța.'
    },
    marketing: { name: 'Marketing', purpose: 'Susțin publicitatea și marketingul alese de organizator.' }
  }
};

export default locale;
